/**
 * CUSTOMER-R4.9 — canonical customer display name.
 * Profile/canonical name wins; Telegram first_name is fallback only.
 */
export function isSyntheticCustomerName(name: string | null | undefined): boolean {
  const n = String(name ?? "").trim().toLowerCase();
  if (!n) return true;
  return (
    n === "telegram" ||
    n === "user" ||
    n === "guest" ||
    n === "customer" ||
    n === "клієнт" ||
    n.startsWith("tg_") ||
    /^user\d+$/i.test(n)
  );
}

export type CustomerNameSources = {
  profileName?: string | null;
  nameSource?: "user" | "telegram" | "profile" | string | null;
  telegramFirstName?: string | null;
};

/**
 * Priority:
 * 1. canonical profile name when name_source is user|profile (or any non-telegram non-synthetic)
 * 2. any non-synthetic profile name
 * 3. Telegram first_name fallback only when profile empty/synthetic
 */
export function resolveCanonicalCustomerName(input: CustomerNameSources): string | null {
  const profile = String(input.profileName ?? "").trim();
  const src = String(input.nameSource ?? "").trim().toLowerCase();
  const tg = String(input.telegramFirstName ?? "").trim();

  if ((src === "user" || src === "profile") && profile && !isSyntheticCustomerName(profile)) {
    return profile;
  }
  if (profile && !isSyntheticCustomerName(profile) && src !== "telegram") {
    return profile;
  }
  if (profile && !isSyntheticCustomerName(profile) && src === "telegram") {
    // Telegram-sourced profile may be used only until user sets a real name;
    // prefer profile string over live TG only if already persisted.
    return profile;
  }
  if (tg && !isSyntheticCustomerName(tg)) return tg;
  if (profile && !isSyntheticCustomerName(profile)) return profile;
  return null;
}
